import classnames from 'classnames';
import Barcode from 'jsbarcode';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import styles from './barcode.module.scss';

/**
 * Generate a canvas QR code image from the provided code
 *
 * @link https://www.npmjs.com/package/qrcode
 * @param {Object} props
 */
const BarCodeImage = (props) => {
  const canvasRef = useRef();
  const { className, code, imageClassName, options, ...rest } = props;

  const defaults = {
    displayValue: false,
    lineColor: '#000',
    margin: 0,
  };

  useEffect(() => {
    if (canvasRef.current) {
      Barcode(canvasRef.current, code, {
        ...defaults,
        ...options,
      });
    }
  });

  return (
    <div className={classnames(className, styles.container)} {...rest}>
      <canvas
        className={classnames(imageClassName, styles.canvas, 'image')}
        data-test-id="barcode-canvas"
        ref={canvasRef}
      />
    </div>
  );
};

BarCodeImage.propTypes = {
  code: PropTypes.string.isRequired,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  options: PropTypes.object,
};

export default BarCodeImage;
